import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { ContentWidth, TextWidth } from '@ta-interaktiv/react-disco-grid'
import ExampleComponent from '../ExampleComponent'
import { Waypoint } from 'react-waypoint'
import { useWindowSize } from 'usehooks-ts'

declare global {
  interface Window {
    chapters: any
  }
}

window.chapters = window.chapters || {}

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  properties = properties || {
    id: 'id',
    order: '0',
    long: 'Eine furchteinflössende Prophezeiung',
    subtitle: undefined,
    short: 'Kapitel 1',
    noImage: 'false',
    source: 'Foto: Bla Blabla',
  }
  const ref = useRef<HTMLDivElement>(null)
  const id = properties?.id || 'missingID'
  const order = +(properties?.order || '0')
  const long = properties?.long
  const short = properties?.short
  const subtitle = properties?.subtitle
  const source = properties?.source
  const noImage = properties?.noImage === 'true'
  const img = properties?.image
  const [screenHeight, setScreenHeight] = useState<number>()
  const { width, height } = useWindowSize()
  useEffect(() => {
    setScreenHeight(height * 0.7)
  }, [width])

  useEffect(() => {
    if (!ref.current) return
    window.chapters[id] = { el: ref.current, title: long, id, order, short }
    const newChapterEvent = new CustomEvent('chapteradded')
    window.dispatchEvent(newChapterEvent)
  }, [ref.current])

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <div ref={ref} />
      {!noImage && screenHeight && (
        <ImageWrapper
          height={screenHeight}
          style={{ backgroundImage: img ? 'url(' + img + ')' : 'unset' }}
        />
      )}
      <TextWidth>
        <Waypoint
          scrollableAncestor={window}
          onEnter={() => {
            const newChapterEvent = new CustomEvent('chapteronscreen', {
              detail: id,
            })
            window.dispatchEvent(newChapterEvent)
          }}
        >
          <Wrapper id={id} className='Wrapper'>
            <ContentWrapper noImage={noImage}>
              {short && <Short colorMode={colorMode}>{short}</Short>}{' '}
              {source && <Source>{source}</Source>}
              {long && <Long colorMode={colorMode}>{long}</Long>}
              {subtitle && <Subtitle>{subtitle}</Subtitle>}{' '}
            </ContentWrapper>
          </Wrapper>
        </Waypoint>
      </TextWidth>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  overflow-x: hidden;
`

const ContentWrapper = styled.div<{ noImage: boolean }>`
  margin-top: ${({ noImage }) => (noImage ? 'unset' : '-4em')};
  display: inline-block;
  width: 100%;
`
const ImageWrapper = styled.div<{ height: number }>`
  display: inline-block;
  width: 100%;
  padding-bottom: ${({ height }) => height + 'px'};
  background-color: #888;
  background-size: cover;
  background-position: 50% 50%;
`
const Wrapper = styled.div`
  width: 100%;

  font-family: var(--font-serif);
  text-align: center;
  margin-top: 15px;
  margin-bottom: 60px;
  padding-top: 15px;
`

const Short = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  font-weight: 300;
  letter-spacing: 1px;
  font-family: var(--font-sans-serif);
  font-size: 18px;
  margin-bottom: 30px;
  display: inline-block;
  /* border-bottom: ${({ colorMode }) =>
    colorMode === 'dark'
      ? '1px solid var(--blue-bright-1)'
      : '1px solid var(--blue-main)'}; */
  padding: 10px 20px;
  background-color: var(--site-background);
  color: ${({ colorMode }) =>
    colorMode === 'dark' ? 'var(--blue-bright-1)' : 'var(--blue-main)'};
`

const Long = styled.h2<{ colorMode: 'light' | 'dark' | undefined }>`
  font-family: var(--font-source);
  font-size: 40px;
  line-height: 1.15em;

  color: ${({ colorMode }) =>
    colorMode === 'dark' ? 'var(--blue-main)' : 'var(--blue-main)'};
  margin-bottom: 20px;
  background: ${({ colorMode }) =>
    colorMode === 'dark'
      ? ' -webkit-linear-gradient(var(--blue-main),var(--text-color))'
      : ' -webkit-linear-gradient(var(--blue-bright-1),var(--text-color))'};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

const Subtitle = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 18px;
  letter-spacing: 0.4px;
  line-height: 1.3em;
  color: var(--text-color);
`
const Source = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 12px;
  letter-spacing: 0.4px;
  line-height: 1.3em;
  color: var(--gray-3);
`

export default MainComponent
